import { createSlice } from "@reduxjs/toolkit";
import { carBrandsCases } from "../extra/cases/laximo/carBrandsCases";
import { CarCatalogOptionsItem } from "../../../types/Car/CarCatalogOptionsItem.interface";

interface LaximoState {
    carBrands: CarCatalogOptionsItem[];
    
    loading: {
        carBrands: boolean;
    };
    error: {
        carBrands: string | null;
    };
}

const initialState: LaximoState = {
    carBrands: [],
    loading: {
        carBrands: false,
    },
    error: {
        carBrands: null,
    },
};

/** Данные из laximo */
const laximoSlice = createSlice({
    name: 'laximo',
    initialState,
    reducers: {
    },
    extraReducers: (builder) => {
        carBrandsCases(builder);
    },
});

export const { } = laximoSlice.actions;
export default laximoSlice.reducer;